/**
 * Shared localStorage write helper.
 * New probe key only — never rename existing `un8.*` keys.
 */

const PROBE_KEY = "un8.storage.probe.v1";

export type LocalWriteResult =
  | { ok: true }
  | { ok: false; reason: "disabled" | "quota" };

export function canUseLocalStorage(): boolean {
  try {
    localStorage.setItem(PROBE_KEY, "1");
    localStorage.removeItem(PROBE_KEY);
    return true;
  } catch {
    return false;
  }
}

export function writeLocal(key: string, value: string): LocalWriteResult {
  try {
    localStorage.setItem(key, value);
    return { ok: true };
  } catch (err) {
    const quota =
      err instanceof DOMException &&
      (err.name === "QuotaExceededError" || err.code === 22 || err.code === 1014);
    return { ok: false, reason: quota ? "quota" : "disabled" };
  }
}

export function storageFailMessage(reason: "disabled" | "quota"): string {
  if (reason === "quota") {
    return "This phone is out of space for saved answers. Free some storage, then try again.";
  }
  return "This browser will not save your answers. Turn off private mode, or allow site data, then reload.";
}
